<template>
  <ul v-if="staff" class="flex flex-col gap-5">
    <li v-for="s in staff" class="flex gap-5">
      <div class="flex flex-col gap-3 sm:p-8 shadow-md flex-1 rounded-lg mt-5">
        <div class="flex items-center justify-between">
          <div class="flex flex-col sm:flex-row gap-4 sm:items-center">
            <span class="font-extrabold text-2xl lg:text-2xl">{{ s.name }}</span>
            <UBadge
              class="inline-block font-bold !bg-transparent dark:!text-white dark:border dark:border-neutral-500 text-neutral-900"
              size="lg"
              >{{ s.position }}</UBadge
            >
            <span v-if="s.tenure_at_school" class="uppercase tracking-wider text-sm font-bold"
              >{{ s.tenure_at_school }} years with team</span
            >
          </div>
        </div>
        <span class="block">{{ s.bio }}</span>
        <DataPointsGrid class="max-w-[750px] mt-6 sm:mt-0" v-if="s.wins || s.loss">
          <DataPoint>
            Wins
            <template #value>{{ s.wins }}</template>
          </DataPoint>
          <DataPoint>
            Losses
            <template #value>{{ s.loss }}</template>
          </DataPoint>
          <DataPoint>
            Ties
            <template #value>{{ s.ties }}</template>
          </DataPoint>
          <DataPoint>
            Win Rate
            <template #value>{{ ((s.wins / (s.loss + s.wins)) * 100).toFixed(2) }}%</template>
          </DataPoint>
        </DataPointsGrid>
      </div>
    </li>
  </ul>
</template>

<script lang="ts" setup generic="T extends Tables<'staff'>">
import type { Tables } from '~/types/database-helpers';

const props = defineProps<{
  staff: T[];
}>();
</script>
